import { memo } from 'react';

import type { KendoProviderProps } from './_provider.type';

import CalendarPropsContextProvider from './context/calendar';
import DropDownListPropsContextProvider from './context/drop-down-list';

/** KendoProvider. */
export default memo(function KendoProvider({ children }: KendoProviderProps) {
  return (
    <DropDownListPropsContextProvider>
      <CalendarPropsContextProvider>{children}</CalendarPropsContextProvider>
    </DropDownListPropsContextProvider>
  );
});
